import { Breakpoint, type SliderConfig } from '@jsmdg/yoshi';
import { PageType } from '../../../shared/enums/pageType';

type ConfigByPageType = {
    [key in PageType]?: SliderConfig;
};

const pageSliderConfigHome: SliderConfig = {
    spaceBetween: 16,
    slidesPerView: 2,
    slidesPerGroup: 2,
    showPagination: true,
    showNavigation: true,
    breakpoints: {
        [Breakpoint.XS]: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 16 },
        [Breakpoint.SM]: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 24 },
        [Breakpoint.MD]: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 24 },
        [Breakpoint.XL]: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 32 },
    },
};

const pageSliderConfig: ConfigByPageType = {
    [PageType.Home]: pageSliderConfigHome,
};

export { pageSliderConfig };
